import styled from "@emotion/styled";
import { Text } from "components";
import { CaretRightIcon } from "components/icons";
import React from "react";
import { Link } from "react-router-dom";
import { SETTING_MENU } from "../menu";
import {
  SettingCaretIconStyle,
  SettingIconStyle,
  SettingLeftStyle,
  SettingMenuItemStyle,
  SettingSectionContainerStyle,
  SettingSectionStyle,
} from "../styles";

export const SettingsNavigationScreen: React.FC = () => {
  return (
    <div className={SettingSectionContainerStyle}>
      {SETTING_MENU.map((item) => (
        <div key={item.label} className={SettingSectionStyle}>
          <Text.Body2XS color="darkGrey">{item.label}</Text.Body2XS>
          {item.items.map((subItem: any) => {
            const Component = subItem.CustomComponent
              ? subItem.CustomComponent
              : subItem.externalLink
                ? A
                : Link;
            return (
              <Component
                key={subItem.id}
                href={subItem.externalLink ? subItem.link : undefined}
                target={subItem.externalLink ? "_blank" : undefined}
                rel={subItem.externalLink ? "noreferrer" : undefined}
                to={subItem.link || undefined}
                style={{ width: "100%", textDecoration: "none" }}
              >
                <div className={SettingMenuItemStyle}>
                  <div className={SettingLeftStyle}>
                    {subItem.Icon && (
                      <subItem.Icon fill="primary" style={SettingIconStyle} />
                    )}
                    <Text.Body>{subItem.label}</Text.Body>
                  </div>

                  <CaretRightIcon
                    fill="highlight/1"
                    style={SettingCaretIconStyle}
                  />
                </div>
              </Component>
            );
          })}
        </div>
      ))}
    </div>
  );
};

const A = styled.a``;
